export const AUTH_TOKEN_TYPE = 'Session';
export const AA_SUSPEND_COOKIE_NAME = (<any>window).AA_SUSPEND_COOKIE_NAME;
export const TMCZ_DOMAIN = (<any>window).TMCZ_DOMAIN;
export const B2B_DOMAIN = (<any>window).B2B_DOMAIN;
export const RP_COMPONENT_PREFIXES = (<any>window).RP_COMPONENT_PREFIXES;
export const RECAPTCHASITEKEY = (<any>window).RECAPTCHASITEKEY;
export const SSO_DOMAIN = (<any>window).SSO_DOMAIN;
